import { connect } from "react-redux";
import { Link, Navigate, Route, Routes, useLocation } from "react-router-dom";

import PaymentHandling from "./PaymentHandling";
import BillingEmails from "@/components/billing/BillingEmails";

const tabs = [
	{
		link: "/admin/payment-and-billing/payment-handling",
		name: "Payment Handling",
	},
	{
		link: "/admin/payment-and-billing/billing-emails",
		name: "Billing Emails",
	},
];

const PaymentAndBilling = ({}) => {
	const location = useLocation();
	const currentTab = location.pathname;

	return (
		<>
			<div className="content">
				<div className="row">
					<div className="col-sm-12">
						<div className="pull-left">
							<h1 className="page-heading">Payment and Billing</h1>
						</div>
					</div>
				</div>
			</div>
			<div className="content bg-white">
				<ul className="nav nav-tabs nav-tabs-alt nav-justified">
					{tabs.map((tab) => {
						return (
							<li className={currentTab === tab.link ? "active" : ""}>
								<Link to={tab.link}>{tab.name}</Link>
							</li>
						);
					})}
				</ul>
				<Routes>
					<Route
						path="payment-handling"
						element={<PaymentHandling />}
					/>
					<Route
						path="billing-emails"
						element={<BillingEmails forAdmin={true} />}
					/>
					<Route
						path="*"
						element={
							<Navigate
								to="/admin/payment-and-billing/payment-handling"
								replace
							/>
						}
					/>
				</Routes>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	return {};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentAndBilling);
